import { connect } from "react-redux";
import { Navigate, Outlet } from "react-router";
import { ROUTES } from "../../libs";
import { AppDispatch, ApplicationState } from "../../store/application-state";
import { PermissionProtectedRouteProps } from "./permission-protected-route.props";

const PermissionProtectedRoute = (props: PermissionProtectedRouteProps) => {
  const isAuthenticated = () => {
    return props.loggedUser !== null &&
      props.loggedUser.token !== "" &&
      props.loggedUser.token !== undefined &&
      props.loggedUser.token !== null
      ? true
      : false;
  };
  const hasAccess = () => {
    return props.premission === props.userRole;
  };
  return (
    <>
      {isAuthenticated() && hasAccess() ? (
        <Outlet />
      ) : (
        <Navigate to={ROUTES.LOGIN} replace />
      )}
    </>
  );
};
const mapStateToProps = (state: ApplicationState) => ({
  loggedUser: state.login.loggedUser,
  userRole: state.login.userRole ?? null,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PermissionProtectedRoute);
